<ng-multiselect-dropdown
  [placeholder]="placeholder"
  [settings]="dropdownSettings"
  [data]="options"
  [ngModel]="selectedOptions"
  (ngModelChange)="selectedOptionsChange.emit($event)"
  style="width: 150px; display: block; margin-bottom: 1rem"
>
</ng-multiselect-dropdown>
